/**
 * Component which used on initial screen to show and select available items.
 */
import { LitElement, css, customElement, html } from 'lit-element';
import {
  B_FLOW_ID,
  C_B_FLOW_ID,
  C_FLOW_ID,
  C_PL_FLOW_ID,
  PL_B_FLOW_ID,
  PL_FLOW_ID,
  TRIPLE_FLOW_ID,
} from '../boilerplate/item-ids';

/**
 * LitElement
 * A simple base class for creating fast, lightweight web components.
 *
 * @docs https://lit-element.polymer-project.org/
 */
@customElement('item-select')
class ItemSelectComponent extends LitElement {
  static get properties() {
    return {
      title: { type: String },
      description: { type: String },
      id: { type: String },
      color: { type: String },
      is_combined: { type: Boolean },
      isChecked: { type: Boolean },
    };
  }

  constructor() {
    super();
    this.title = '';
    this.description = '';
    this.id = '';
    this.color = '';
    this.is_combined = false;
    this.isChecked = null;

    this.formChangeEvent = (kasko) => this.formChanged(kasko);
  }

  static get styles() {
    return css`
      .item-select-container {
        display: flex;
        border: 1px solid #EFE6DC;
        background: #fff;
        margin-top: 17px;
      }

      .items-combined-container {
        padding: 18px 0px 18px 22px;
        width: 90%;
      }

      .items-combined-container .item-note {
        font-size: 18px;
        color: #000;
      }

      .item-select-icon {
        min-width: 131px;
        min-height: 131px;
        background-position: center;
        background-repeat: no-repeat;
      }

      .blue-item .item-select-icon {
        background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='92px' height='92px' viewBox='0 0 39 40' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ctitle%3EIcon/Hausrat%3C/title%3E%3Cdefs%3E%3Crect id='path-1' x='0' y='0' width='27' height='27'%3E%3C/rect%3E%3C/defs%3E%3Cg id='Icon/Hausrat' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Iconset/Prozent-Copy-3' transform='translate(6.242424, 6.000000)'%3E%3Cmask id='mask-2' fill='white'%3E%3Cuse xlink:href='%23path-1'%3E%3C/use%3E%3C/mask%3E%3Cg id='Background'%3E%3C/g%3E%3Cpath d='M8.56730769,4.15384615 C6.71264758,4.15384615 5.19230769,5.67418599 5.19230769,7.52884615 L5.19230769,9.35933763 C3.74462465,9.4923791 2.59615385,10.721674 2.59615385,12.2019231 C2.59615385,13.4941857 3.48768564,14.5509054 4.67307692,14.8984749 L4.67307692,20.5096154 C4.67307692,22.077575 5.96088653,23.3653846 7.52884615,23.3653846 L19.4711538,23.3653846 C21.0391134,23.3653846 22.3269231,22.077575 22.3269231,20.5096154 L22.3269231,14.8984749 C23.5123145,14.5509054 24.4038462,13.4941857 24.4038462,12.2019231 C24.4038462,10.721674 23.2553752,9.4923791 21.8076923,9.35933763 L21.8076923,7.52884615 C21.8076923,5.67418599 20.2873524,4.15384615 18.4326923,4.15384615 L8.56730769,4.15384615 Z M8.56730769,5.71153846 L18.4326923,5.71153846 C19.4452245,5.71153846 20.25,6.51631396 20.25,7.52884615 L20.25,9.57433137 C18.742266,10.1124803 17.6538462,11.5539667 17.6538462,13.2403846 L17.6538462,15.3173077 C17.6538462,15.4705041 17.5474272,15.5769231 17.3942308,15.5769231 L9.60576923,15.5769231 C9.45257279,15.5769231 9.34615385,15.4705041 9.34615385,15.3173077 L9.34615385,13.2403846 C9.34615385,11.5539667 8.257734,10.1124803 6.75,9.57433137 L6.75,7.52884615 C6.75,6.51631396 7.5547755,5.71153846 8.56730769,5.71153846 Z M5.45192308,10.9038462 C6.75181679,10.9038462 7.78846154,11.9404909 7.78846154,13.2403846 L7.78846154,15.3173077 C7.78846154,16.3116113 8.61146567,17.1346154 9.60576923,17.1346154 L17.3942308,17.1346154 C18.3885343,17.1346154 19.2115385,16.3116113 19.2115385,15.3173077 L19.2115385,13.2403846 C19.2115385,11.9404909 20.2481832,10.9038462 21.5480769,10.9038462 C22.2740789,10.9038462 22.8461538,11.4759211 22.8461538,12.2019231 C22.8461538,12.927925 22.2740789,13.5 21.5480769,13.5 C21.1179499,13.500043 20.7692738,13.8487191 20.7692308,14.2788462 L20.7692308,20.5096154 C20.7692308,21.2356173 20.1971558,21.8076923 19.4711538,21.8076923 L7.52884615,21.8076923 C6.80284419,21.8076923 6.23076923,21.2356173 6.23076923,20.5096154 L6.23076923,14.2788462 C6.23072622,13.8487191 5.88205012,13.500043 5.45192308,13.5 C4.72592117,13.5 4.15384615,12.927925 4.15384615,12.2019231 C4.15384615,11.4759211 4.72592117,10.9038462 5.45192308,10.9038462 Z' id='Shape' fill='%23FFFFFF' mask='url(%23mask-2)'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
        background-color: #433894;
        background-size: 120px;
      }

      .orange-item .item-select-icon {
        background-image: url("data:image/svg+xml,%0A%3Csvg width='92px' height='92px' viewBox='0 0 40 40' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg id='Symbols' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Icon-big/schutz' transform='translate(-6.000000, -6.000000)' fill='%23fff'%3E%3Cpath d='M25.976562,5.97833217 C25.1489014,5.99144597 24.488127,6.67232351 24.5,7.5 L24.5,9.0625 C13.660999,9.8823601 6,19.513377 6,30.5 C6.00047238,31.1451858 6.41341856,31.7178072 7.02545144,31.9219658 C7.63748432,32.1261245 8.31150535,31.9160879 8.6992188,31.400391 L9.4453125,30.40625 C11.3736694,27.835615 15.164902,27.996987 16.869141,30.720703 L17.226562,31.292969 C17.4730737,31.6882903 17.8892619,31.9466451 18.3529153,31.9921688 C18.8165688,32.0376926 19.2750579,31.8652179 19.59375,31.525391 C20.960708,30.067571 22.691625,29.188946 24.5,28.875 L24.5,39.25 C24.5,41.338031 22.838031,43 20.75,43 C18.575733,43 17,41.588031 17,39.5 C17.0076504,38.9590461 16.7234371,38.455878 16.2561907,38.1831684 C15.7889444,37.9104589 15.2110556,37.9104589 14.7438093,38.1831684 C14.2765629,38.455878 13.9923496,38.9590461 14,39.5 C14,43.209969 17.126267,46 20.75,46 C24.459969,46 27.5,42.959969 27.5,39.25 L27.5,28.875 C29.308375,29.188946 31.039292,30.067571 32.40625,31.525391 C32.7419571,31.8831074 33.2313577,32.054082 33.7167862,31.9832335 C34.2022147,31.9123851 34.6223335,31.6086658 34.841797,31.169922 C36.297399,28.258718 40.118365,27.769639 42.261719,30.21875 L43.371094,31.488281 C43.7827291,31.958508 44.442755,32.124286 45.0277309,31.9043768 C45.6127068,31.6844676 46,31.1249455 46,30.5 C46,19.513377 38.339001,9.8823601 27.5,9.0625 L27.5,7.5 C27.5058186,7.09438128 27.347119,6.70369699 27.0600898,6.41703583 C26.7730605,6.13037467 26.3821729,5.97217648 25.976562,5.97833217 Z M25.818359,12.007812 C25.9408563,12.0236578 26.0648418,12.0243141 26.1875,12.009766 C34.825605,12.104285 41.26934,18.622738 42.691406,26.996094 C39.625371,25.136612 35.769464,25.71475 33.380859,28.425781 C29.092839,24.953068 22.945384,24.943822 18.648438,28.400391 C16.272209,25.613666 12.386831,25.010601 9.3398438,26.763672 C10.8404747,18.499246 17.256414,12.098552 25.818359,12.007812 Z' id='Shape'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
        background-color: #FFB122;
        background-size: 60px;
      }

      .red-item .item-select-icon {
        background-image: url("data:image/png;base64,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");
        background-color: #F05D23;
        background-size: 79px;
      }

      .item-select-description {
        padding: 15px 23px;
        max-width: 50%;
      }

      .item-select-description .item-title,
      .item-select-description .item-note,
      .item-select-description-combination .item-title {
        font-size: 18px;
        line-height: 1.2;
      }

      .item-select-description-combination .item-title {
        color: #000;
      }

      .blue-item .item-select-description .item-title {
        color: #433894;
      }

      .orange-item .item-select-description .item-title {
        color: #FB8900;
      }

      .red-item .item-select-description .item-title {
        color: #F05D23;
      }

      .item-select-description .item-note {
        color: #000;
      }

      .item-select-optin {
        display: flex;
        flex: 1;
        align-self: center;
        justify-content: flex-end;
        padding-right: 18px;
      }

      .checkbox-container input {
        padding: 0;
        height: initial;
        width: initial;
        margin-bottom: 0;
        display: none;
        cursor: pointer;
      }

      .checkbox-container label {
        position: relative;
        cursor: pointer;
      }

      .checkbox-container.disabled {
        opacity: .55;
      }

      .checkbox-container.disabled label {
        cursor: not-allowed;
      }

      .checkbox-container label:before {
        content: '';
        -webkit-appearance: none;
        background-color: transparent;
        border: 1px solid #EFE6DC;
        border-radius: 3px;
        box-shadow: inset 1px 2px 9px rgba(0, 0, 0, .1) !important;
        padding: 3px;
        height: 27px;
        width: 27px;
        display: inline-block;
        position: relative;
        vertical-align: middle;
        cursor: pointer;
        margin-right: 5px;
      }

      .checkbox-container.disabled label:before {
        cursor: not-allowed;
      }

      .blue-item .checkbox-container input:checked + label:before {
        background-color: #433894;
      }

      .orange-item .checkbox-container input:checked + label:before {
        background-color: #FB8900;
      }

      .red-item .checkbox-container input:checked + label:before {
        background-color: #F05D23;
      }

      .black-item .checkbox-container input:checked + label:before {
        background-color: #000;
      }

      .checkbox-container input:checked + label:after {
        content: '';
        display: block;
        position: absolute;
        left: 6px;
        transform: translateY(-50%) !important;
        top: 50%;
        width: 27px;
        height: 27px;
        border-width: 0 2px 2px 0;
        background-position: center;
        background-size: 16px;
        background-repeat: no-repeat;
        background-image: url("data:image/svg+xml,%0A%3Csvg width='20px' height='22px' viewBox='0 0 20 22' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg id='Symbols' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='haken' transform='translate(-7.000000, -5.000000)'%3E%3Cg transform='translate(7.000000, 5.000000)'%3E%3Cmask id='mask-3' fill='white'%3E%3Cuse xlink:href='%23path-2'%3E%3C/use%3E%3C/mask%3E%3Cg id='Clip-2'%3E%3C/g%3E%3Cpolyline id='Fill-1' fill='%23fff' points='17.038 0.624 5.54 17.042 2.33 12.439 0 14.071 5.54 22 19.368 2.256 17.038 0.624'%3E%3C/polyline%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
      }

      .item-select-description-with-optin {
        display: flex;
        justify-content: space-between;
        width: calc(100% - 131px);
        height: 131px;
      }

      .item-select-container.combined {
        height: 131px;
      }

      @media all and (-ms-high-contrast: none) {
        .checkbox-container input:checked + label:after {
          left: 0;
        }
      }

      @media only screen and (max-width: 576px) {
        .item-select-container {
          flex-direction: column;
        }

        .item-select-container.combined {
          flex-direction: row;
          height: auto;
        }

        .item-select-description-with-optin {
          width: 100%;
        }
      }
    `;
  }

  render() {
    return html`
      <div class="item-select-container ${this.color}-item ${this.is_combined ? 'combined' : ''}">
        ${
          this.is_combined
            ? html`
          <div class="items-combined-container">
            <div class="item-select-description-combination">
                <div class="item-title">${this.title}</div>
            </div>
            <div class="item-select-icons">
              <?xml version="1.0" encoding="UTF-8"?>
              <svg width="39px" height="40px" viewBox="0 0 39 40" version="1.1" xmlns="http://www.w3.org/2000/svg"
                   xmlns:xlink="http://www.w3.org/1999/xlink">
                <title>Icon/Hausrat</title>
                <defs>
                  <rect id="path-1" x="0" y="0" width="27" height="27"></rect>
                </defs>
                <g id="Icon/Hausrat" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <circle id="Oval-Copy-4" fill="#433894" cx="19.3770492" cy="20" r="19.6229508"></circle>
                  <g id="Iconset/Prozent-Copy-3" transform="translate(6.242424, 6.000000)">
                    <mask id="mask-2" fill="white">
                      <use xlink:href="#path-1"></use>
                    </mask>
                    <g id="Background"></g>
                    <path
                      d="M8.56730769,4.15384615 C6.71264758,4.15384615 5.19230769,5.67418599 5.19230769,7.52884615 L5.19230769,9.35933763 C3.74462465,9.4923791 2.59615385,10.721674 2.59615385,12.2019231 C2.59615385,13.4941857 3.48768564,14.5509054 4.67307692,14.8984749 L4.67307692,20.5096154 C4.67307692,22.077575 5.96088653,23.3653846 7.52884615,23.3653846 L19.4711538,23.3653846 C21.0391134,23.3653846 22.3269231,22.077575 22.3269231,20.5096154 L22.3269231,14.8984749 C23.5123145,14.5509054 24.4038462,13.4941857 24.4038462,12.2019231 C24.4038462,10.721674 23.2553752,9.4923791 21.8076923,9.35933763 L21.8076923,7.52884615 C21.8076923,5.67418599 20.2873524,4.15384615 18.4326923,4.15384615 L8.56730769,4.15384615 Z M8.56730769,5.71153846 L18.4326923,5.71153846 C19.4452245,5.71153846 20.25,6.51631396 20.25,7.52884615 L20.25,9.57433137 C18.742266,10.1124803 17.6538462,11.5539667 17.6538462,13.2403846 L17.6538462,15.3173077 C17.6538462,15.4705041 17.5474272,15.5769231 17.3942308,15.5769231 L9.60576923,15.5769231 C9.45257279,15.5769231 9.34615385,15.4705041 9.34615385,15.3173077 L9.34615385,13.2403846 C9.34615385,11.5539667 8.257734,10.1124803 6.75,9.57433137 L6.75,7.52884615 C6.75,6.51631396 7.5547755,5.71153846 8.56730769,5.71153846 Z M5.45192308,10.9038462 C6.75181679,10.9038462 7.78846154,11.9404909 7.78846154,13.2403846 L7.78846154,15.3173077 C7.78846154,16.3116113 8.61146567,17.1346154 9.60576923,17.1346154 L17.3942308,17.1346154 C18.3885343,17.1346154 19.2115385,16.3116113 19.2115385,15.3173077 L19.2115385,13.2403846 C19.2115385,11.9404909 20.2481832,10.9038462 21.5480769,10.9038462 C22.2740789,10.9038462 22.8461538,11.4759211 22.8461538,12.2019231 C22.8461538,12.927925 22.2740789,13.5 21.5480769,13.5 C21.1179499,13.500043 20.7692738,13.8487191 20.7692308,14.2788462 L20.7692308,20.5096154 C20.7692308,21.2356173 20.1971558,21.8076923 19.4711538,21.8076923 L7.52884615,21.8076923 C6.80284419,21.8076923 6.23076923,21.2356173 6.23076923,20.5096154 L6.23076923,14.2788462 C6.23072622,13.8487191 5.88205012,13.500043 5.45192308,13.5 C4.72592117,13.5 4.15384615,12.927925 4.15384615,12.2019231 C4.15384615,11.4759211 4.72592117,10.9038462 5.45192308,10.9038462 Z"
                      id="Shape" fill="#FFFFFF" mask="url(#mask-2)"></path>
                  </g>
                </g>
              </svg>

              <?xml version="1.0" encoding="UTF-8"?>
              <svg width="39px" height="40px" viewBox="0 0 39 40" version="1.1" xmlns="http://www.w3.org/2000/svg"
                   xmlns:xlink="http://www.w3.org/1999/xlink">
                <title>Icon/Plus</title>
                <g id="Icon/Plus" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <polygon id="+" fill="#000000" fill-rule="nonzero"
                           points="21.39 29 21.39 22.035 28.355 22.035 28.355 18.29 21.39 18.29 21.39 11.325 17.645 11.325 17.645 18.29 10.68 18.29 10.68 22.035 17.645 22.035 17.645 29"></polygon>
                </g>
              </svg>

              <?xml version="1.0" encoding="UTF-8"?>
              <svg width="39px" height="40px" viewBox="0 0 39 40" version="1.1" xmlns="http://www.w3.org/2000/svg"
                   xmlns:xlink="http://www.w3.org/1999/xlink">
                <title>Icon/Haftpflicht</title>
                <g id="Icon/Haftpflicht" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <circle id="Oval-Copy-4" fill="#FFB122" cx="19.3770492" cy="20" r="19.6229508"></circle>
                  <g id="Iconset/Prozent-Copy-3" transform="translate(6.242424, 5.000000)">
                    <rect id="Bounding-Box" x="-12.5" y="-12.5" width="52" height="52"></rect>
                    <path
                      d="M13.4878303,3.10413401 C13.0580834,3.1109431 12.714989,3.46447567 12.7211538,3.89423077 L12.7211538,4.70552885 C7.09321102,5.13122544 3.11538462,10.1319458 3.11538462,15.8365385 C3.11562989,16.1715388 3.33004425,16.4688614 3.64783056,16.5748669 C3.96561686,16.6808723 4.31558932,16.5718149 4.51690207,16.3040492 L4.90429688,15.7878606 C5.90555911,14.4531078 7.87408373,14.5368971 8.75897706,15.9511343 L8.94456104,16.2482724 C9.07255747,16.4535354 9.2886552,16.5876811 9.52939834,16.6113184 C9.77014149,16.6349558 10.0082032,16.5454016 10.1736779,16.368953 C10.8834445,15.612008 11.7821899,15.1557989 12.7211538,14.9927885 L12.7211538,20.3798077 C12.7211538,21.4639776 11.8582084,22.3269231 10.7740385,22.3269231 C9.64509213,22.3269231 8.82692308,21.5937853 8.82692308,20.5096154 C8.83089542,20.2287355 8.68332309,19.9674751 8.44071442,19.8258759 C8.19810574,19.6842767 7.8980481,19.6842767 7.65543943,19.8258759 C7.41283076,19.9674751 7.26525843,20.2287355 7.26923077,20.5096154 C7.26923077,22.4359454 8.89248479,23.8846154 10.7740385,23.8846154 C12.7003685,23.8846154 14.2788462,22.3061378 14.2788462,20.3798077 L14.2788462,14.9927885 C15.2178101,15.1557989 16.1165555,15.612008 16.8263221,16.368953 C17.0006316,16.5546904 17.2547434,16.6434657 17.5067928,16.606679 C17.7588422,16.5698923 17.9769809,16.4121918 18.0909331,16.1843826 C18.8467264,14.6727959 20.8306895,14.418851 21.9435849,15.6905048 L22.5196065,16.3496844 C22.7333401,16.5938407 23.0760459,16.6799177 23.3797833,16.5657341 C23.6835208,16.4515505 23.8846154,16.1610294 23.8846154,15.8365385 C23.8846154,10.1319458 19.906789,5.13122544 14.2788462,4.70552885 L14.2788462,3.89423077 C14.2818674,3.68362105 14.1994656,3.48076574 14.0504312,3.33192245 C13.9013968,3.18307915 13.6984359,3.10093779 13.4878303,3.10413401 Z M13.4056864,6.23482546 C13.4692908,6.24305311 13.5336679,6.24339388 13.5973558,6.23584004 C18.0825257,6.28491721 21.4283112,9.66949858 22.1666916,14.0172027 C20.5747119,13.0517024 18.5726063,13.3518894 17.3323691,14.7595401 C15.1058972,12.9564007 11.9139494,12.9515999 9.68284281,14.7463569 C8.4490316,13.2994035 6.43162379,12.9862736 4.84953428,13.896522 C5.62870802,9.60537773 8.96006112,6.28194046 13.4056864,6.23482546 Z"
                      id="Shape" fill="#FFFFFF"></path>
                  </g>
                </g>
              </svg>

              <?xml version="1.0" encoding="UTF-8"?>
              <svg width="39px" height="40px" viewBox="0 0 39 40" version="1.1" xmlns="http://www.w3.org/2000/svg"
                   xmlns:xlink="http://www.w3.org/1999/xlink">
                <title>Icon/Plus</title>
                <g id="Icon/Plus" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <polygon id="+" fill="#000000" fill-rule="nonzero"
                           points="21.39 29 21.39 22.035 28.355 22.035 28.355 18.29 21.39 18.29 21.39 11.325 17.645 11.325 17.645 18.29 10.68 18.29 10.68 22.035 17.645 22.035 17.645 29"></polygon>
                </g>
              </svg>

              <?xml version="1.0" encoding="UTF-8"?>
              <svg width="39px" height="40px" viewBox="0 0 39 40" version="1.1" xmlns="http://www.w3.org/2000/svg"
                   xmlns:xlink="http://www.w3.org/1999/xlink">
                <title>Icon/Gebäude</title>
                <defs>
                  <rect id="path-1" x="0" y="0" width="27" height="27"></rect>
                </defs>
                <g id="Icon/Gebäude" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <circle id="Oval-Copy-4" fill="#F05D23" cx="19.3770492" cy="20" r="19.6229508"></circle>
                  <g id="Iconset/Prozent-Copy-3" transform="translate(6.242424, 5.000000)">
                    <mask id="mask-2" fill="white">
                      <use xlink:href="#path-1"></use>
                    </mask>
                    <g id="Background"></g>
                    <path
                      d="M12.9807692,3.64272837 C12.3843294,3.64272837 11.7881169,3.83673931 11.2952973,4.22483476 C11.2949593,4.22483454 11.2946213,4.22483454 11.2942833,4.22483476 L5.11929087,9.09160927 C4.18282588,9.82962675 3.63461538,10.9573212 3.63461538,12.150203 L3.63461538,21.5419921 C3.63461538,22.5362956 4.45761962,23.3592998 5.45192308,23.3592998 L20.5096154,23.3592998 C21.5039189,23.3592998 22.3269231,22.5362956 22.3269231,21.5419921 L22.3269231,12.150203 C22.3269231,10.9573212 21.7787125,9.82962675 20.8422476,9.09160927 L20.7692308,9.03278977 L20.7692308,4.93269231 C20.7691878,4.50256527 20.4205117,4.15388916 19.9903846,4.15384615 L17.3942308,4.15384615 C16.9641037,4.15388916 16.6154276,4.50256527 16.6153846,4.93269231 L16.6153846,5.76021635 L14.6662411,4.22483476 C14.1734215,3.83673936 13.5772091,3.64272837 12.9807692,3.64272837 Z M12.9807692,5.19636418 C13.235089,5.19636418 13.4894903,5.28087995 13.7028245,5.4488807 L16.9125227,7.97708821 C17.1468539,8.16144976 17.4658675,8.19586727 17.7341292,8.06572909 C18.0023909,7.93559091 18.1728256,7.66373386 18.1730769,7.36557248 L18.1730769,5.71153846 L19.2115385,5.71153846 L19.2115385,9.41105769 C19.2117021,9.64964608 19.3212025,9.87499997 19.5086766,10.0225734 L19.878831,10.3146407 C20.4419046,10.7583925 20.7692308,11.4333535 20.7692308,12.150203 L20.7692308,21.5419921 C20.7692308,21.6951885 20.6628118,21.8016074 20.5096154,21.8016074 L5.45192308,21.8016074 C5.29872653,21.8016074 5.19230769,21.6951885 5.19230769,21.5419921 L5.19230769,12.150203 C5.19230769,11.4333535 5.51963378,10.7583925 6.08270746,10.3146407 L12.2587139,5.4488807 C12.4720482,5.28087995 12.7264495,5.19636418 12.9807692,5.19636418 Z M8.04807692,13.4939151 C7.61794988,13.4939151 7.26923077,13.8426343 7.26923077,14.2727613 L7.26923077,18.4266074 C7.26923077,18.8567345 7.61794988,19.2054536 8.04807692,19.2054536 L11.1634615,19.2054536 C11.5935886,19.2054536 11.9423077,18.8567345 11.9423077,18.4266074 L11.9423077,14.2727613 C11.9423077,13.8426343 11.5935886,13.4939151 11.1634615,13.4939151 L8.04807692,13.4939151 Z M14.7980769,13.4939151 C14.3679499,13.4939151 14.0192308,13.8426343 14.0192308,14.2727613 L14.0192308,18.4266074 C14.0192308,18.8567345 14.3679499,19.2054536 14.7980769,19.2054536 L17.9134615,19.2054536 C18.3435886,19.2054536 18.6923077,18.8567345 18.6923077,18.4266074 L18.6923077,14.2727613 C18.6923077,13.8426343 18.3435886,13.4939151 17.9134615,13.4939151 L14.7980769,13.4939151 Z M8.82692308,15.0516074 L10.3846154,15.0516074 L10.3846154,17.6477613 L8.82692308,17.6477613 L8.82692308,15.0516074 Z M15.5769231,15.0516074 L17.1346154,15.0516074 L17.1346154,17.6477613 L15.5769231,17.6477613 L15.5769231,15.0516074 Z"
                      id="Shape" fill="#FFFFFF" mask="url(#mask-2)"></path>
                  </g>
                </g>
              </svg>
            </div>
            <div class="item-select-description-combination">
              <div class="item-note">${this.kasko.getTranslation(this.description)}</div>
            </div>
          </div>
          <div class="item-select-optin">
            <div class="checkbox-container">
              <input type="checkbox"
                     id="item-checkbox-${this.id}"
                     ?checked=${this.isChecked}
                     @change=${() => this.selectItem()}
              >
              <label for="item-checkbox-${this.id}"></label>
            </div>
          </div>
          </div>
        `
            : html`
          <div class="item-select-icon">
          </div>
          <div class="item-select-description-with-optin">
            <div class="item-select-description">
              <div class="item-title">${this.title}</div>
              <div class="item-note">${this.kasko.getTranslation(this.description)}</div>
            </div>
            <div class="item-select-optin">
              <div class="checkbox-container">
                <input type="checkbox"
                       id="item-checkbox-${this.id}"
                       ?checked=${this.isChecked}
                       @change=${() => this.selectItem()}
                >
                <label for="item-checkbox-${this.id}"></label>
              </div>
            </div>
          </div>
        `
        }

      </div>
    `;
  }

  connectedCallback() {
    super.connectedCallback();
    this.prefillSelection();
    this.kasko.addEventListener('form-changed', this.formChangeEvent);
    this.setAttribute('title', this.kasko.getTranslation(this.title));
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.kasko.removeEventListener('form-changed', this.formChangeEvent);
  }

  prefillSelection() {
    const prefilledItemId = this.kasko.getState('input').item_id;
    const isDuoItem =
      prefilledItemId === C_B_FLOW_ID ||
      prefilledItemId === C_PL_FLOW_ID ||
      prefilledItemId === PL_B_FLOW_ID;

    // update form state with same values as in input state
    if (prefilledItemId) {
      this.kasko.dispatchEvent('set-form-input', {
        item_id: prefilledItemId,
        item_color: undefined,
      });
    }

    if (!isDuoItem) {
      this.isChecked = prefilledItemId === this.id;
      return;
    }

    let itemPair = [];
    if (prefilledItemId === C_B_FLOW_ID) {
      itemPair = [C_FLOW_ID, B_FLOW_ID];
    }

    if (prefilledItemId === C_PL_FLOW_ID) {
      itemPair = [C_FLOW_ID, PL_FLOW_ID];
    }

    if (prefilledItemId === PL_B_FLOW_ID) {
      itemPair = [PL_FLOW_ID, B_FLOW_ID];
    }

    this.isChecked = itemPair.includes(this.id);
  }

  selectItem() {
    const itemId = this.getItemId();
    this.isChecked = !this.isChecked;

    this.kasko.dispatchEvent('set-form-input', {
      item_id: !this.isChecked && itemId === this.id ? null : itemId,
      item_color: undefined,
    });
    this.kasko.dispatchEvent('set-state-input', {
      item_id: !this.isChecked && itemId === this.id ? null : itemId,
      item_color: undefined,
    });
  }

  formChanged({ current }) {
    const checkboxContainer = this.shadowRoot.querySelector('.checkbox-container');

    if (!checkboxContainer || !current.item_id) {
      return;
    }

    // if user selects TRIPLE item, then unselect individual items and select TRIPLE item
    if (current.item_id === TRIPLE_FLOW_ID) {
      if (this.id !== TRIPLE_FLOW_ID) {
        this.shadowRoot.getElementById(`item-checkbox-${this.id}`).checked = false;
        this.isChecked = false;
        return;
      }

      this.shadowRoot.getElementById(`item-checkbox-${this.id}`).checked = true;
      this.isChecked = true;
      return;
    }

    // if user is not selected TRIPLE item, then make sure that its unselected
    if (this.id === TRIPLE_FLOW_ID) {
      this.shadowRoot.getElementById(`item-checkbox-${this.id}`).checked = false;
      this.isChecked = false;
    }
  }

  getItemId() {
    const touchedItem = this.id;
    const currentItem = this.kasko.getFormState().item_id || this.kasko.getState('input').item_id;

    if (!touchedItem && !currentItem) {
      throw new Error(
        'At least argument must be defined in `getItemId` method in `item-select` component.',
      );
    }

    if ((touchedItem && !currentItem) || touchedItem === currentItem) {
      return touchedItem;
    }

    if (
      (touchedItem === C_FLOW_ID && currentItem === PL_FLOW_ID) ||
      (touchedItem === PL_FLOW_ID && currentItem === C_FLOW_ID)
    ) {
      return C_PL_FLOW_ID;
    }

    if (
      (touchedItem === C_FLOW_ID && currentItem === B_FLOW_ID) ||
      (touchedItem === B_FLOW_ID && currentItem === C_FLOW_ID)
    ) {
      return C_B_FLOW_ID;
    }

    if (
      (touchedItem === PL_FLOW_ID && currentItem === B_FLOW_ID) ||
      (touchedItem === B_FLOW_ID && currentItem === PL_FLOW_ID)
    ) {
      return PL_B_FLOW_ID;
    }

    if (
      (touchedItem === PL_FLOW_ID && currentItem === C_PL_FLOW_ID) ||
      (touchedItem === B_FLOW_ID && currentItem === C_B_FLOW_ID) ||
      (touchedItem === C_FLOW_ID && currentItem === TRIPLE_FLOW_ID)
    ) {
      return C_FLOW_ID;
    }

    if (
      (touchedItem === C_FLOW_ID && currentItem === C_PL_FLOW_ID) ||
      (touchedItem === B_FLOW_ID && currentItem === PL_B_FLOW_ID) ||
      (touchedItem === PL_FLOW_ID && currentItem === TRIPLE_FLOW_ID)
    ) {
      return PL_FLOW_ID;
    }

    if (
      (touchedItem === C_FLOW_ID && currentItem === C_B_FLOW_ID) ||
      (touchedItem === PL_FLOW_ID && currentItem === PL_B_FLOW_ID) ||
      (touchedItem === B_FLOW_ID && currentItem === TRIPLE_FLOW_ID)
    ) {
      return B_FLOW_ID;
    }

    if (
      touchedItem === TRIPLE_FLOW_ID ||
      (touchedItem === PL_FLOW_ID && currentItem === C_B_FLOW_ID) ||
      (touchedItem === C_FLOW_ID && currentItem === PL_B_FLOW_ID) ||
      (touchedItem === B_FLOW_ID && currentItem === C_PL_FLOW_ID)
    ) {
      return TRIPLE_FLOW_ID;
    }

    return null;
  }
}

export default ItemSelectComponent;
